import React from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';

export default function Calendar({sessions}) {

  const events = sessions.map((session) => ({
    title: session.name,
    date: session.date_from,
    backgroundColor: session.company.color,
    borderColor: session.company.color
  }));

  return (
    <FullCalendar
      plugins={[dayGridPlugin]}
      initialView="dayGridMonth"
      events={events}
    />
  );
}
